<template>
  <div class="expandable-box">
    <!-- Gray title box -->
    <button @click="toggleExpanded" class="title-box">
      <h3>{{(isExpanded?'- ':'+ ')+ title }}</h3>
    </button>


    <!-- White description box (only shown when expanded) -->
    <div v-show="isExpanded" class="description-box" id="transcript">
    </div>
  </div>
</template>

<script>
export default {
  name: 'ExpandableBox',
  props: {
    title: {
      type: String,
      required: true
    },
    description: {
      type: String,
      required: true
    }
  },
  mounted(){
    document.getElementById('transcript').innerHTML=  this.description ; 
    
  },
  data() {
    return {
      isExpanded: false
    };
  },
  methods: {
    toggleExpanded() {
      this.isExpanded = !this.isExpanded;
    }
  },
  watch:{
    description(){
      document.getElementById('transcript').innerHTML=this.description ;  
    }  
  }
};
</script>

<style lang="css" >

</style>
